import { getCustomerIoFieldDescription } from "./customerio/EnhancedCustomerIoFieldDescription";
import { getIntercomFieldDescription } from "./intercom/EnhancedIntercomFieldDescription";
import { getMergeFieldDescription } from "./merge/EnhancedMergeFieldDescription";
import { getNotionFieldDescription } from "./notion/EnhancedNotionFieldDescription";
import { getZendeskFieldDescription } from "./zendesk/EnhancedZendeskFieldDescription";
import {
  ClientMappingApiType,
  ENHANCED_CUSTOMERIO_FIELDS,
  ENHANCED_MERGE_FIELDS,
  ENHANCED_ZENDESK_FIELDS,
  MERGE_NOTIFICATION_TYPES,
  ENHANCED_NOTION_FIELDS,
  ENHANCED_INTERCOM_FIELDS,
} from "@avenueops/shared-types";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import Tooltip from "components/generic-building-blocks/Tooltip";

interface Props {
  clientMappingApiType: ClientMappingApiType;
  fullFieldName: string;
}

export function FieldDescriptionPopup({ clientMappingApiType, fullFieldName }: Props) {
  return (
    <Tooltip text={<EnhancedFieldDescription clientMappingApiType={clientMappingApiType} fullFieldName={fullFieldName} />}>
      <InformationCircleIcon className="h-4 w-4" />
    </Tooltip>
  );
}

function EnhancedFieldDescription({ clientMappingApiType, fullFieldName }: Props) {
  return (
    <div className="flex flex-row items-center mt-2 text-white text-sm">
      {clientMappingApiType === "ZENDESK" && ENHANCED_ZENDESK_FIELDS.has(fullFieldName)
        ? getZendeskFieldDescription(fullFieldName)
        : clientMappingApiType === "CUSTOMER_IO" && ENHANCED_CUSTOMERIO_FIELDS.has(fullFieldName)
        ? getCustomerIoFieldDescription(fullFieldName)
        : clientMappingApiType === "NOTION" && ENHANCED_NOTION_FIELDS.includes(fullFieldName)
        ? getNotionFieldDescription(fullFieldName)
        : MERGE_NOTIFICATION_TYPES.has(clientMappingApiType) && ENHANCED_MERGE_FIELDS.has(fullFieldName)
        ? getMergeFieldDescription(fullFieldName)
        : clientMappingApiType === "INTERCOM" && ENHANCED_INTERCOM_FIELDS.has(fullFieldName)
        ? getIntercomFieldDescription(fullFieldName)
        : null}
    </div>
  );
}
